module.exports = __webpack_public_path__ + "img/Maleficae_Megnyito_W82.a476762e.jpg";